import { render } from "./Show.vue?vue&type=template&id=1e63e889"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"
script.render = render

export default script